module.exports = __webpack_public_path__ + "img/magnifying-glass.fe6a29fe.png";